import React from "react";
import "./BICard.css";
import { getRandomColor, createImageFromInitials } from "./Utils";
import Image from "../assets/images/BIIcon.svg";
import { useDispatch } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { postBiRolePermissions } from "../store/actions";
import ProgressBar from "react-bootstrap/ProgressBar";
class Card extends React.Component {
  render() {
    return <div className="bicard">{this.props.children}</div>;
  }
}

class SelectableCard extends React.Component {
  render() {
    return (
      <Card className="column">
        <div data-id={this.props.dataid}>{this.props.children}</div>
      </Card>
    );
  }
}

const SelectableTitleCard = ({
  bi_id,
  icon,
  title,
  status,
  dataid,
  owner,
  navigation_url,
  momentum_score,
  task_progress,
}) => {
  const dispatch = useDispatch();
  const handleBICardClick = (navigation_url) => {
    dispatch({
      type: "SET_SELECTED_BI",
      payload: {
        value: bi_id,
        label: title,
      },
    });
    localStorage.setItem("bi_id", bi_id);
    localStorage.removeItem("product_id")
    // if (navigation_url) {
    //   window.location.href = navigation_url;
    // } else {
    //   window.location.href = "/workboard";
    // }
    dispatch(postBiRolePermissions(bi_id, navigation_url || "/workboard"));
  };
   const progress = Math.min(Math.max(Number(momentum_score) || 0, 0),100);
   const radius = 18;
   const circumference = 2 * Math.PI * radius;
   const strokeDashoffset =circumference - (progress / 100) * circumference;

  return (
    <SelectableCard dataid={dataid}>
      <div onClick={() => handleBICardClick(navigation_url)}>
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div style={{ display: "flex"}}>
            {/* <img alt="icon" src={icon} style={{ width: "50px" }} /> */}
         {/* Momentum Progress Ring */}
          <div className="momentum-progress">
            <svg
              className="momentum-progress-ring"
              width="46"
              height="46"
              viewBox="0 0 46 46"
            >
              {/* Background circle */}
              <circle
                className="momentum-progress-bg"
                cx="23"
                cy="23"
                r={radius}
              />

              {/* Progress circle */}
              <circle
                className="momentum-progress-value"
                cx="23"
                cy="23"
                r={radius}
                strokeDasharray={circumference}
                strokeDashoffset={strokeDashoffset}
              />
            </svg>

            {/* Percentage */}
            <div className="momentum-progress-text">
              {progress}%
            </div>
          </div>
          </div>
          <div style={{ marginLeft: "10px", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div title={title} className="bi_title">
                {title}
              </div>
              <div>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-${owner}`}>{owner}</Tooltip>}
                >
                  <img
                    style={{ width: 25, borderRadius: 25, marginLeft: "10px" }}
                    id="preview"
                    src={createImageFromInitials(
                      25,
                      owner,
                      getRandomColor(owner)
                    )}
                    alt="profile-pic"
                  />
                </OverlayTrigger>
              </div>
            </div>
            <div className="status_desc">{status ? status : "Workboard"}</div>
          </div>
        </div>
        <div style={{ marginTop: "10px", height: "30px" }}>
          <ProgressBar className="custom-progress">
            <ProgressBar  variant="success" now={task_progress.completed_percent} key={1} />
            <ProgressBar variant="warning" now={task_progress.pending_percent} key={2} />
            <ProgressBar  variant="danger" now={task_progress.overdue_percent} key={3} />
          </ProgressBar>
          <div className="progress-text">
            <span>{task_progress.completed} completed</span>
            <span>{task_progress.pending} pending</span>
            <span>{task_progress.overdue} overdue</span>
          </div>
        </div>

      </div>
    </SelectableCard>
  );
};

class SelectableCardList extends React.Component {
  render() {
    var { contents } = this.props;
    var content = contents.map((cardContent, i) => {
      var {
        bi_name,
        description,
        id,
        bi_owner,
        last_screen_name,
        navigatation_url,
        name,
        momentum_score,
        task_progress,
      } = cardContent;
      return (
        <div style={{width: "100%" }} key={i}>
          <SelectableTitleCard
            bi_id={name}
            key={i}
            icon={Image}
            title={bi_name}
            description={description}
            dataid={id}
            status={last_screen_name}
            owner={bi_owner}
            navigation_url={navigatation_url}
            momentum_score={momentum_score}
            task_progress={task_progress}
          />
        </div>
      );
    });
    return <div className="bicardlist">{content}</div>;
  }
}

class Example extends React.Component {
  render() {
    return (
      <SelectableCardList
        multiple={this.props.multiple}
        maxSelectable={this.props.maxSelectable}
        contents={this.props.cardContents}
      />
    );
  }
}

export default Example;
